import * as React from 'react';

function world(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 3.333C10.81 3.333 3.333 10.81 3.333 20c0 9.19 7.477 16.667 16.667 16.667 9.19 0 16.667-7.477 16.667-16.667 0-9.19-7.477-16.667-16.667-16.667zM6.667 20c0-1.498.26-2.937.718-4.282L10 18.333l3.333 3.334V25l3.334 3.333L18.333 30v3.218C11.768 32.393 6.667 26.787 6.667 20zm23.883 8.122c-1.088-.877-2.738-1.455-3.883-1.455V25a3.333 3.333 0 00-3.334-3.333h-6.666v-5A3.333 3.333 0 0020 13.333v-1.666h1.667A3.333 3.333 0 0025 8.333v-.685C29.88 9.63 33.333 14.417 33.333 20c0 2.941-.98 5.799-2.783 8.122z"
				fill="currentColor"
			/>
		</svg>
	);
}

export default world;
